<template>
  <div>
    <Modal v-model="flag" title="草稿箱" :mask-closable="false" width="80%" @on-cancel="cancelDraftModal">
      <listFilter :formItems="formItems" :filter="filter" @searchTableInfo="searchTableInfo" @resetTableInfo="resetTableInfo"  />
      <div class="tableWrap">
        <Table border :columns="columns" size="small" stripe :data="dataSource" disabled-hover row-key="id" ref="tableRef" />
        <div style="margin: 10px; overflow: hidden">
          <div style="float: right">
            <Page
              show-total
              show-sizer
              :total="totalCount"
              :current="filter.pageIndex"
              :page-size="filter.pageSize"
              :page-size-opts="[10, 25, 50, 100]"
              @on-change="changePage"
              @on-page-size-change="pageSizeChange"
            />
          </div>
        </div>
      </div>
      <div slot="footer">
        <Button @click="cancelDraftModal()">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import listMixins from '@/mixins/listMixins';
import { formItems, getColumns } from './config';
import { delDraftApi } from '@/api/lauchApproval';
import { instApplyDetailApi } from '@/api/approvalTask';
export default {
  name: 'launchApprovalDraftModal',
  mixins: [listMixins],
  data() {
    return {
      flag: false,
      formItems,
      columns: getColumns({
        editDraft: this.editDraft,
        delDraft: this.delDraft
      }),
      filter: {
        pageIndex: 1,
        pageSize: 10,
        tplName: ''
      }
    };
  },
  props: {
    draftModalFlag: Boolean
  },
  watch: {
    draftModalFlag(val) {
      this.flag = val;
    }
  },
  computed: { ...mapState('approvalDraftList', ['dataSource', 'totalCount']) },
  methods: {
    ...mapActions('approvalDraftList', ['getTableInfo']),
    // 弹框关闭
    cancelDraftModal() {
      this.$emit('cancelDraftModal', false);
    },
    // 编辑
    editDraft(id) {
      this.$router.push({ path: 'launchApprovalDetail', query: { id, mode: 'draft' } });
      // instApplyDetailApi(id).then(res => {
      //   const { data, code } = res.data;
      //   if (code == 200) {
      //     const trendsForm = { formData: data.formCurrData, renderJson: data.formDesignDef };
      //     localStorage.setItem('trendsForm', JSON.stringify(trendsForm));

      //   }
      // });
    },
    // 删除
    delDraft(id) {
      this.$Modal.confirm({
        title: '删除',
        content: '是否删除？',
        onOk: () => {
          delDraftApi(id).then(res => {
            console.log(res);
            const { code, msg } = res.data;
            if (code == 200) {
              this.$Message.success(msg || '操作成功');
              this.getTableInfo({ filter: this.filter });
            }
          });
        }
      });
    }
  }
};
</script>

<style>

</style>
